import { useUiStore } from '@app/core/ui/stores/ui.store';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { useSidenavContext } from '../SidenavContext';
import { getSidenavToggleButtonSx } from '../sidenav-colors';
import { getSidenavRailPaddingLeft, SIDENAV_TOKENS } from '../sidenav-tokens';

const collapseLabelMessage = defineMessage({
  id: 'core.sidenav.collapseTooltip',
  defaultMessage: 'Cerrar menú',
});

const expandLabelMessage = defineMessage({
  id: 'core.sidenav.expandTooltip',
  defaultMessage: 'Abrir menú',
});

/** Toggles sidenav expanded/collapsed state using the UI store. */
export function NavStateToggler() {
  const { collapsed } = useSidenavContext();
  const toggleSidenav = useUiStore((state) => state.toggleSidenav);
  const $t = useIntl().formatMessage;
  const label = collapsed ? $t(expandLabelMessage) : $t(collapseLabelMessage);
  const toggleSize = SIDENAV_TOKENS.toggleButtonSize;
  // Centers the 32px control in the collapsed rail; same inset when expanded so it does not jump.
  const togglePaddingLeft = getSidenavRailPaddingLeft(toggleSize);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        pl: `${togglePaddingLeft}px`,
        pr: SIDENAV_TOKENS.contentPaddingX,
        alignItems: 'center',
      }}
    >
      <Tooltip title={label} placement="right">
        <IconButton
          size="small"
          onClick={() => toggleSidenav()}
          sx={(theme) => getSidenavToggleButtonSx(theme, { size: toggleSize })}
        >
          {collapsed ? (
            <ChevronRightIcon sx={{ fontSize: SIDENAV_TOKENS.iconSize }} />
          ) : (
            <ChevronLeftIcon sx={{ fontSize: SIDENAV_TOKENS.iconSize }} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
